'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hasOpacity"],
  _excluded2 = ["borderColor", "borderWidth", "className", "color", "iconClassName", "iconColor", "iconName", "onClick", "selected", "size", "opacity"];
import I18n from 'I18n';
import { OLAF } from 'HubStyleTokens/colors';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import memoizeOne from 'react-utils/memoizeOne';
import styled from 'styled-components';
import UIButton from '../button/UIButton';
import { FieldsetContextConsumer } from '../context/FieldsetContext';
import { rgba } from '../core/Color';
import { callIfPossible } from '../core/Functions';
import SyntheticEvent from '../core/SyntheticEvent';
import UIIconCircle from '../icon/UIIconCircle';
import { getIconNamePropType } from '../utils/propTypes/iconName';
import { uniqueId } from '../utils/underscore';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SIZES = {
  small: 16,
  default: 20
};
const getStyle = size => ({
  height: size * 2
});
const Button = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    use: "unstyled"
  }, rest));
}).withConfig({
  displayName: "UIColorSwatch__Button",
  componentId: "sc-116imt3-0"
})([".hs-private.hs-private.hs-private &&{", ";}"], ({
  hasOpacity
}) => hasOpacity && `background-image: url('${require('bender-url!ui-images/optimized/transparent_background.svg')}');`);
class UIColorSwatch extends PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = () => {
      callIfPossible(this.props.onClick, SyntheticEvent(this.props.color));
    };
    this._getStyle = memoizeOne(getStyle);
    this._id = uniqueId('color-input');
  }
  render() {
    const _this$props = this.props,
      {
        borderColor,
        borderWidth,
        className,
        color,
        iconClassName,
        iconColor,
        iconName,
        selected,
        size,
        opacity
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded2);
    const hasOpacity = opacity != null;
    const backgroundColor = hasOpacity ? rgba(color, opacity / 100) : color;
    const computedColor = selected ? iconColor : 'transparent';
    const describedById = `${this._id}-desc`;
    return /*#__PURE__*/_jsx(FieldsetContextConsumer, {
      children: fieldsetContext => {
        const computedSize = size != null ? size : SIZES[fieldsetContext.size];
        return /*#__PURE__*/_jsxs(Button, {
          "aria-describedby": describedById,
          className: className,
          hasOpacity: hasOpacity,
          onClick: this.handleClick,
          style: this._getStyle(computedSize),
          children: [/*#__PURE__*/_jsx("div", {
            "aria-hidden": true,
            className: "sr-only",
            id: describedById,
            children: color ? I18n.text('ui.UIColorSwatch.label', {
              value: color
            }) : I18n.text('ui.UIColorSwatch.noColorLabel')
          }), /*#__PURE__*/_jsx(UIIconCircle, Object.assign({}, rest, {
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            borderWidth: borderWidth,
            color: computedColor,
            iconClassName: iconClassName,
            legacy: true,
            name: iconName,
            size: computedSize
          }))]
        });
      }
    });
  }
}
UIColorSwatch.displayName = 'UIColorSwatch';
UIColorSwatch.defaultProps = {
  borderWidth: 0,
  iconColor: OLAF,
  iconName: 'success',
  selected: false
};
UIColorSwatch.propTypes = {
  borderColor: PropTypes.string,
  borderWidth: PropTypes.number,
  color: PropTypes.string,
  iconColor: PropTypes.string,
  iconName: getIconNamePropType(),
  iconClassName: PropTypes.string,
  selected: PropTypes.bool,
  size: PropTypes.number,
  opacity: PropTypes.number,
  onClick: PropTypes.func
};
export default UIColorSwatch;